import { isMobile } from 'shared/utilities/utils';
import useWidth from './useWidth';

// to cut down on boilerplate even further
export default function useIsMobile() {
  const width = useWidth();
  return isMobile(width);
}
